<template>
  <season-form />
</template>

<script>
import SeasonForm from '@/components/forms/SeasonForm'
export default {
  components: {
    SeasonForm
  }
}
</script>
